import { action } from 'easy-peasy';
import { IActionSetHospitalEvents } from '../types';

const setHospitalEvents: IActionSetHospitalEvents = action((state, payload) => {
  const hasMore = state.pagination.itemsPerPage === payload.length;

  state.events = payload;
  state.pagination.page += 1;
  state.pagination.hasMore = hasMore;
});

export default setHospitalEvents;
